// extracted by mini-css-extract-plugin
export default {"paragraph":"ParagraphText_paragraph__OPjV9"};